











































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin, generalDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { QueryManipulator } from '@/router'
import { OsdConfig, OsdImageAlignment } from '@/types/api'
// const ColorPicker = require('vue-color/src/components/Chrome.vue')
import { Chrome } from 'vue-color'
import { deepCopy } from '@/utils'
import OsdImagePreview from '@/components/OsdImage.vue'

type osd_type_t = 'image' | 'text'
type crud_t = 'create' | 'edit'

const OSD_DEFAULT_FIELDS = {
  id: -1,
  name: '',
  isPicture: true,
  opacity: 100,
  image: {
    id: -1,
    alignment: OsdImageAlignment.center,
  },
  text: {
    center: false,
    shiftX: 0,
    shiftY: 0,
    content: '',
    fontSize: 16,
    color: '#0f0',
  },
}

export default mixins(generalDialogMixin).extend({
  components: {
    ColorPicker: Chrome,
    OsdImagePreview
  },
  data (): {
    copiedOsd: OsdConfig,
    osdType: osd_type_t,
    ALL_OSD_TYPES: osd_type_t[],
    showColorPicker: boolean
  } {
    return {
      copiedOsd: deepCopy(OSD_DEFAULT_FIELDS),
      osdType: 'text',
      ALL_OSD_TYPES: ['text', 'image'],
      showColorPicker: false
    }
  },
  computed: {
    textContentRules (): Array<() => string | boolean> {
      const txt = this.copiedOsd.text.content
      return [
        () => {
          if (!!txt && !txt.match(/^[-_?!#@+=()A-Za-z0-9 '",.*]+$/)) { return this.$t('validate.osdTextCharSet') as string }
          return true
        }
      ]
    },
    crudType (): crud_t {
      const name = this.$route.name
      if (!name) { return 'create' }
      if (name.includes('osd_create')) { return 'create' }
      return 'edit'
    },
    title (): string { return (this.crudType === 'create' ? this.$t('osd.create') : this.$t('osd.edit')) as string },
    invalid (): boolean {
      if (!this.copiedOsd.name) {return true}
      if (this.osdType === 'text') {
        return (!this.copiedOsd.text.content)
      } else {
        return false
      }
    }
  },
  watch: {
    show (nv: boolean) {
      if (nv) {
        this.prepareVmData()
      }
    },
  },
  methods: {
    prepareVmData () {
      if (this.crudType === 'create') {
        this.copiedOsd = deepCopy(OSD_DEFAULT_FIELDS)
      } else {
        const osdId = ~~this.$route.params['osdid']
        const tmp = this.$state.device.osd.list.find(x => x.id === osdId)
        if (!tmp) { console.error('[To Developer] Impossible'); return }
        this.copiedOsd = deepCopy(tmp)
      }
      this.osdType = this.copiedOsd.isPicture ? 'image' : 'text'
    },
    openImgSelector (currImgId: number) {
      this.$router.push({ name: `${this.$route.name}_img`, query: { selected_img_id: currImgId + '' } })
    },
    async apply () {
      this.copiedOsd.isPicture = this.osdType === 'image'
      if (this.crudType === 'create') {
        const ok = await easyapi.createOsd(this.copiedOsd)
        if (ok) {
          this.$emit('create')
          this.closeThisDialog()
          return
        }
      } else {
        const ok = await easyapi.modifyOsd(this.copiedOsd)
        if (ok) {
          this.$emit('edit')
          this.closeThisDialog()
          return
        }
      }
    },
  },
  mounted () {
    this.prepareVmData()
  },
})
